import React, { FC, useState } from 'react'

import { Button } from '@mui/material'
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown'
import SidebarNavTab from '@app/pages/Dashboard/SideBar/components/SidebarNavTab/SidebarNavTab'
import { SidebarNavAccordeonMenu } from '@app/pages/Dashboard/SideBar/components/SidebarNavAccordeon/styled'

interface SidebarNavAccordeonProps {
	readonly openIconSlot?: React.ReactNode
	readonly openLabel?: string
	readonly menuData?: React.ReactNode
	readonly minimize?: boolean
	readonly sx?: object
	readonly checked?: boolean
}

const SidebarNavAccordeon: FC<SidebarNavAccordeonProps> = ({
	openIconSlot,
	openLabel,
	menuData,
	minimize,
	sx,
	checked,
}: SidebarNavAccordeonProps) => {
	const [open, setOpen] = useState<boolean>(false)

	const handleClickOpen: React.MouseEventHandler<HTMLButtonElement> = () => {
		setOpen(v => !v)
	}

	return (
		<>
			<SidebarNavTab
				component={Button}
				checked={checked}
				onClick={handleClickOpen}
				sx={sx}
			>
				{openIconSlot}

				{openLabel}

				<ArrowDropDownIcon
					sx={{
						ml: 'auto',
						transform: open ? 'rotate(180deg)' : 'rotate(0deg)',
						transition: '0.25s',
					}}
				/>
			</SidebarNavTab>

			{open && (
				<SidebarNavAccordeonMenu
					sx={{
						display: minimize && open ? 'none' : 'block',
					}}
				>
					{menuData}
				</SidebarNavAccordeonMenu>
			)}
		</>
	)
}

export default SidebarNavAccordeon
